export enum EStorage {
  GROUP_LIFE_INSURANCE = "GROUP_LIFE_INSURANCE",
  COMPLIANCE = "COMPLIANCE",
  CAC_DOCUMENT = "CAC_DOCUMENT",
  DISCREPANCY = "DISCREPANCY",
  EMPLOYEE_REMOVAL = "EMPLOYEE_REMOVAL",
  SUPPORT_ATTACHMENT = "SUPPORT_ATTACHMENT",
}
